import { ajaxCall } from "@/shared/connection/ajax-call";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";

const ENDPOINT = "/pricings";

export const pricingOnboardingService = {
    sendOnboardData({ mode, productDetails, promptDescription, lang }) {
        return ajaxCall
            .post(`${ENDPOINT}/onboarding`, { mode, productDetails, promptDescription, lang })
            .catch(handleErrorByMessage());
    },
};
